<template>
  <div class="app-container cheliang-page">
    <div class="search-div common-section-bg one-click-toolbar">
      <div class="shaixuan-item">
        <el-select
          v-model="filters.community_id"
          filterable
          clearable
          placeholder="筛选小区（可搜索）"
          size="mini"
          style="width:280px"
          @change="handleSearch"
        >
          <el-option v-for="item in communityOptions" :key="item.id" :label="item.label || item.name" :value="item.id" />
        </el-select>
      </div>
      <div class="shaixuan-item">
        <el-button type="primary" size="mini" class="btn-primary-blue" icon="el-icon-search" @click="handleSearch">查询</el-button>
        <el-button size="mini" @click="resetFilters">重置</el-button>
        <el-button
          type="primary"
          size="mini"
          class="btn-primary-blue"
          icon="el-icon-refresh"
          :loading="syncing"
          :disabled="!filters.community_id || syncing"
          @click="startOneClickSync"
        >
          一键同步
        </el-button>
      </div>
    </div>

    <div v-if="syncing || syncMessage" class="common-section-bg sync-status-panel">
      <div class="section-title">同步进度</div>
      <div v-if="syncing" class="sync-progress-row">
        <span>总数 {{ syncProgress.total || 100 }}</span>
        <span>已完成 {{ syncProgress.synced || 0 }}</span>
        <el-progress :percentage="syncPercent" :stroke-width="14" style="flex:1;margin:0 12px" />
      </div>
      <p class="phase-message">{{ syncMessage || '等待任务开始…' }}</p>
      <p v-if="syncing" class="sync-tip">将依次执行：车位信息 → 车位物业费 → 车辆信息（海康/捷卫士）</p>
    </div>

    <div v-loading="listLoading" class="common-section-bg common-section-body table-wrap">
      <div class="section-title history-title">同步历史</div>
      <el-table :data="syncHistory" size="mini" style="width: 100%; min-height: 320px">
        <el-table-column prop="project" label="小区" min-width="140" show-overflow-tooltip />
        <el-table-column prop="total" label="总数" width="80" align="center" />
        <el-table-column prop="synced" label="已完成" width="80" align="center" />
        <el-table-column prop="start_time" label="开始时间" min-width="155" show-overflow-tooltip />
        <el-table-column prop="end_time" label="结束时间" min-width="155" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.end_time || '—' }}</template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="90" align="center">
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.status === '已完成' ? 'success' : (scope.row.status === '失败' ? 'danger' : 'warning')"
              size="mini"
            >{{ scope.row.status }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="message" label="阶段说明" min-width="220" show-overflow-tooltip />
      </el-table>
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.size"
        @pagination="getHistoryList"
      />
      <el-empty v-if="!listLoading && !syncHistory.length" description="暂无同步历史" :image-size="80" />
    </div>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import chechangOneClickSync from '@/api/tianzheng/chechangOneClickSync'

export default {
  name: 'CheliangOneClickSync',
  components: { Pagination },
  data() {
    return {
      communityOptions: [],
      filters: {
        community_id: null
      },
      syncHistory: [],
      listLoading: false,
      listQuery: { page: 1, size: 10 },
      total: 0,
      syncing: false,
      syncProgress: { total: 0, synced: 0 },
      syncMessage: '',
      currentTaskId: null,
      syncTimer: null
    }
  },
  computed: {
    syncPercent() {
      const total = Number(this.syncProgress.total) || 0
      const synced = Number(this.syncProgress.synced) || 0
      if (total <= 0) return 0
      return Math.min(100, Math.round(synced / total * 100))
    }
  },
  created() {
    this.loadCommunityOptions()
    this.getHistoryList()
  },
  beforeDestroy() {
    this.clearSyncTimer()
  },
  methods: {
    loadCommunityOptions() {
      chechangOneClickSync.communitySelect().then(res => {
        if (res.code === 200) {
          this.communityOptions = res.result || []
        }
      })
    },
    getHistoryList() {
      this.listLoading = true
      chechangOneClickSync.syncHistory({
        community_id: this.filters.community_id || undefined,
        page: this.listQuery.page,
        size: this.listQuery.size
      }).then(res => {
        this.listLoading = false
        if (res.code === 200) {
          this.syncHistory = res.result.list || []
          this.total = res.result.total || 0
        }
      }).catch(() => { this.listLoading = false })
    },
    handleSearch() {
      this.listQuery.page = 1
      this.getHistoryList()
    },
    resetFilters() {
      this.filters.community_id = null
      this.listQuery.page = 1
      this.getHistoryList()
    },
    startOneClickSync() {
      if (!this.filters.community_id) {
        this.$message.warning('请选择小区后再同步')
        return
      }
      this.$confirm('将依次同步车位信息、车位物业费、车辆信息，耗时可能较长，是否继续？', '一键同步', { type: 'warning' })
        .then(() => {
          this.clearSyncTimer()
          this.syncing = true
          this.syncMessage = '任务已提交，等待队列执行…'
          this.syncProgress = { total: 100, synced: 0 }
          chechangOneClickSync.sync({ community_id: this.filters.community_id }).then(res => {
            if (res.code !== 200) {
              this.syncing = false
              this.$message.error(res.message || '同步失败')
              return
            }
            this.currentTaskId = res.result.task_id
            this.pollSyncProgress()
            this.syncTimer = setInterval(() => { this.pollSyncProgress() }, 2000)
            this.listQuery.page = 1
            this.getHistoryList()
          }).catch(() => { this.syncing = false })
        }).catch(() => {})
    },
    pollSyncProgress() {
      if (!this.currentTaskId) return
      chechangOneClickSync.syncProgress({ task_id: this.currentTaskId }).then(res => {
        if (res.code !== 200) return
        const data = res.result
        this.syncProgress = { total: data.total, synced: data.synced }
        this.syncMessage = data.message || ''
        if (data.status === 'completed' || data.status === 'failed') {
          this.finishSync(data.status === 'failed')
        }
      })
    },
    finishSync(failed) {
      this.clearSyncTimer()
      this.syncing = false
      this.listQuery.page = 1
      this.getHistoryList()
      if (failed) {
        this.$message.error(this.syncMessage || '一键同步失败')
        return
      }
      this.$message.success(this.syncMessage || '一键同步完成')
    },
    clearSyncTimer() {
      if (this.syncTimer) {
        clearInterval(this.syncTimer)
        this.syncTimer = null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../styles/page.scss';

.one-click-toolbar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.sync-status-panel {
  margin-bottom: 12px;
  padding: 12px 16px;
}

.sync-progress-row {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  font-size: 13px;
  color: #606266;
}

.phase-message {
  margin: 0;
  font-size: 13px;
  color: #303133;
}

.sync-tip {
  margin: 8px 0 0;
  font-size: 12px;
  color: #909399;
}

.history-title {
  margin-bottom: 12px;
}
</style>
